const login = {
  "email": "メールアドレス",
  "password": "パスワード",
  "button": "ログイン",
  "title": "ログイン",
  "remember_me": "ログイン状態を保持する",
  "forgot_pass": "パスワードを忘れた場合",
}

export default login;